<div class="container">
    <div class="btn-close" (click)="onClose()">
        <i class="fa fa-close"></i>
    </div>
    <ng-image-slider class="imageslider" [images]="data.images" [imageSize]="data.imageSize"></ng-image-slider>
</div>

